import { render } from "./AddSharedCollectionPopup.vue?vue&type=template&id=a5db7412&scoped=true"
import script from "./AddSharedCollectionPopup.vue?vue&type=script&lang=js"
export * from "./AddSharedCollectionPopup.vue?vue&type=script&lang=js"

import "./AddSharedCollectionPopup.vue?vue&type=style&index=0&id=a5db7412&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5db7412"]])

export default __exports__